import type { Person, PersonChecklist } from '@vigeo/shared';
import { ExceptionsList, VerdictReasons } from '@/features/readiness';
import { PersonHistoryPanel } from '../PersonHistoryPanel.js';
import { TimelinePanel } from '@/features/timeline';
import { usePersonStyles } from './styles.js';

/** The History link section. Moved unchanged from `pages/PersonPage.tsx` (#462 §5). */
export interface HistoryStepProps {
  readonly person: Person;
  readonly canEdit: boolean;
  readonly requirements: PersonChecklist['items'];
  readonly ready: PersonChecklist | undefined;
}

export function HistoryStep({ person, canEdit, requirements, ready }: HistoryStepProps) {
  const styles = usePersonStyles();
  return <div className={styles.page}>
    <section className={styles.card} aria-labelledby="timeline-heading"><h3 id="timeline-heading" className={styles.h}>Timeline</h3><TimelinePanel personId={person.id} /></section>
    <PersonHistoryPanel personId={person.id} canEdit={canEdit} requirements={requirements} />
    {ready ? <details className={styles.disclosure}><summary className={styles.summary}>Readiness explanations and exceptions</summary><VerdictReasons checklist={ready} /><ExceptionsList checklist={ready} /></details> : null}
  </div>;
}
